var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function MoneyQuestionIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M124 29H4a2 2 0 00-2 2v65.7a2 2 0 002 2h120a2 2 0 002-2V31a2 2 0 00-2-2z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M64 89c13.807 0 25-11.193 25-25S77.807 39 64 39 39 50.193 39 64s11.193 25 25 25z",
      fill: "#009CEB"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M61.915 76.368h2.972v-3.963h-2.972v3.963zM59.438 58.04c.166-1.486 1.156-3.302 4.459-3.302 3.467 0 4.458 2.477 4.458 3.963 0 4.623-6.11 4.458-6.11 10.732h2.312c0-5.449 6.11-4.953 6.11-10.732 0-3.137-2.312-5.944-6.77-5.944-3.963 0-6.605 2.146-6.77 5.283h2.311z",
      fill: "#fff"
    })))
  }));
}

export default MoneyQuestionIllustration;